import type { SimpleMarketplaceResponse } from '@yoop/data-access-model';
import { MarketplaceState } from '@yoop/data-access-model';

/**
 * Predicate for cancelled marketplaces
 * @param marketplace
 */
export const cancelled = (marketplace: SimpleMarketplaceResponse): boolean =>
  marketplace && marketplace.state === MarketplaceState.CANCELLED;
